module.exports = __webpack_public_path__ + "static/media/welcome.8efa1026.svg";